import script from "./user-top-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./user-top-bar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__